// @flow

import * as React from 'react';
import {useState} from 'react';
import Box from 'sail/Box';
import Button from 'sail/Button';
import Group from 'sail/Group';
import {TextInput} from 'sail/Input';
import type {Article} from 'docs/data';
import {XRaySidebarSection} from './XRaySidebarSection';

type Status = 'waiting' | 'success';

type PublicUrlInputProps = {|
  article: Article,
|};

export const PublicUrl = ({article}: PublicUrlInputProps) => {
  const [status, setStatus] = useState<Status>('waiting');

  const url = `https://stripe.com${article.path}`;

  const handleFocus = (event: SyntheticFocusEvent<>) => {
    if (event.currentTarget instanceof HTMLInputElement) {
      event.currentTarget.select();
    }
  };

  const handleCopy = () => {
    setStatus('success');
    navigator.clipboard.writeText(url);
    setTimeout(() => setStatus('waiting'), 2000);
  };

  return (
    <XRaySidebarSection title="Public URL">
      <Group direction="horizontal" spacing={4}>
        <Box flexGrow={1}>
          <TextInput
            id="xray-publicUrl"
            readOnly
            value={url}
            onFocus={handleFocus}
          />
        </Box>
        <Button
          icon={status === 'waiting' ? 'clipboard' : 'checkmark'}
          label="Copy to clipboard"
          hideLabel
          onClick={handleCopy}
        />
      </Group>
    </XRaySidebarSection>
  );
};
